import * as angular from 'angular';

// The angularjs module for 'mymessages'
// This module is imported in each of the
export const mymessagesModule = angular.module('mymessages', ['ui.router']);
